import React, { useEffect, useState } from "react";
import axios from "axios";
import secureLocalStorage from "react-secure-storage";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "react-tabs/style/react-tabs.css";
import { IoArrowBack } from "react-icons/io5";
import Shearchbar from "./Shearchbar";
import Navbar from "./Navbar";
import Manubar from "./Manubar";

const UserProfile = () => {
  let _id = secureLocalStorage.getItem("n_id");
  let token = secureLocalStorage.getItem("n_token");
  let [get_user_profile, setget_user_profile] = useState([]);
  let [profilevalue, setprofilevalue] = useState({
    user_id: _id,
    full_name: "",
    email: "",
    user_image: "",
    pin: "",
  });

  useEffect(() => {
    const fetchUserProfile = async () => {
      try {
        const items = { user_id: _id };

        const res = await axios.post(
          `${process.env.REACT_APP_API}website/get_user_profile`,
          items,
          {
            headers: {
              token: token,
            },
          },
        );

        if (res.data.result) {
          setget_user_profile(res.data.data);
        }
      } catch (error) {
        console.log("Error fetching profile", error);
      }
    };

    fetchUserProfile();
  }, [_id, token]);

  let profil_input_Hanel = (e) => {
    setprofilevalue({ ...profilevalue, [e.target.name]: e.target.value });
  };

  let profile_form_handel = (e) => {
    e.preventDefault();
    let formdata = new FormData();
    formdata.append("user_id", profilevalue.user_id);
    formdata.append("full_name", profilevalue.full_name);
    formdata.append("email", profilevalue.email);
    formdata.append("user_image", profilevalue.user_image);

    axios
      .post(
        `${process.env.REACT_APP_API}website/update_user_profile`,
        formdata,
        {
          headers: {
            token: token,
          },
        },
      )
      .then((res) => {
        if (res.data.result) {
          toast.success(res.data.msg);
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  return (
    <div>
      <ToastContainer position="top-center" />
      <div className="modal fade offcanvas-modal" id="exampleModal">
        <div className="modal-dialog offcanvas-dialog">
          <div className="modal-content">
            <Manubar />
          </div>
        </div>
      </div>

      <header>
        <Shearchbar />

        <Navbar />
      </header>
      <div
        className="tab-pane fade active show"
        id="account-info"
        role="tabpanel"
      >
        <div
          className="myaccount-content"
          style={{ padding: "2rem", borderRadius: "12px" }}
        >
          <div
            style={{
              position: "relative",
              marginBottom: "1.5rem",
              textAlign: "center",
            }}
          >
            <h3
              style={{
                color: "#160015",
                fontWeight: "700",
                margin: 0,
              }}
            >
              Edit Profile
            </h3>
          </div>
          <div className="account-details-form">
            <div className="row">
              <div className="col-lg-12 col-sm-12 col-md-6">
                <form method="post" onSubmit={profile_form_handel}>
                  <div className="form-group">
                    <label
                      htmlFor="name"
                      style={{ color: "#160015", fontWeight: "600" }}
                    >
                      Full Name:
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      onChange={profil_input_Hanel}
                      name="full_name"
                      defaultValue={get_user_profile?.full_name}
                      style={{
                        border: "1px solid #160015",
                        borderRadius: "6px",
                        color: "#160015",
                      }}
                    />
                  </div>
                  <div className="form-group">
                    <label
                      htmlFor="pwd"
                      style={{ color: "#160015", fontWeight: "600" }}
                    >
                      Email:
                    </label>
                    <input
                      type="email"
                      className="form-control"
                      onChange={profil_input_Hanel}
                      name="email"
                      defaultValue={get_user_profile?.email}
                      style={{
                        border: "1px solid #160015",
                        borderRadius: "6px",
                        color: "#160015",
                      }}
                    />
                  </div>
                  <div className="form-group">
                    <label
                      htmlFor="num"
                      style={{ color: "#160015", fontWeight: "600" }}
                    >
                      Phone Number:
                    </label>
                    <input
                      type="number"
                      className="form-control"
                      disabled
                      defaultValue={get_user_profile?.mobile_no}
                      style={{
                        border: "1px solid #ccc",
                        borderRadius: "6px",
                        color: "#666",
                        backgroundColor: "#f5f5f5",
                      }}
                    />
                  </div>
                  <div className="col-12 text-center mt-4">
                    <button
                      className="btn"
                      style={{
                        backgroundColor: "#123764",
                        color: "#fff",
                        fontWeight: "600",
                        borderRadius: "6px",
                        padding: "10px 30px",
                        width: "100%",
                      }}
                    >
                      Update
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default UserProfile;
